<template>
  <div class="download-section container">
     <!-- left -->
    <article class="listpage-left-title">
      <div class="line1">
        <div>DOWNLOAD</div>
        <div>下载专区</div>
      </div>
      <div class="line2">
        <div :class="tabActive === index? 'active': '' "
          v-for="(item, index) in tabList" :key="index" 
          @click="getActiveList(index)">{{item}}</div>
      </div>
    </article>

    <!-- 列表 -->
    <div class="main">
      <div class="search-con">
        <el-input placeholder="请输入标题名称" v-model="searchtitle" />
        <el-button type="primary" @click="getActiveList(tabActive);">查询</el-button>
        <el-button @click="searchtitle = null; getActiveList(tabActive);">重置</el-button>
      </div>

      <template v-if="dataList.length > 0">
        <ul>
          <li class="item" v-for="v in dataList" :key="v.id">
            <div class="item-title text-overflow-ellipsis">{{v.title}}</div>
            <div class="item-date">{{v.modifyTime|filterTime}}</div>
            <div @click="handleDownload(v)" class="downloadbtn">
              <img src="@/assets/images/download/ic_xz@2x.png" />
              <el-button type="text">下载</el-button>
            </div>
          </li>
        </ul>
        <el-pagination
          :current-page="pagedata.page"
          :page-size="pagedata.size"
          :total="pagedata.total"
          @current-change="sizeChange"
          :page-sizes="[3, 5, 10, 20]"
          layout="prev, pager, next"
          background
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </template>

      <div class="emptydom" v-else>
        <img src="@/assets/images/empty/none_pic@2x.png" />
      </div>
    </div>

  </div>
</template>

<script>
import downloadSectionApi from "@/api/downloadSection";
import { mapState } from "vuex";

export default {
  created() {
    this.downloadFile()
  },
  data() {
    return {
      tabActive: 0,
      tabList: ['资料下载', '工具下载', '其他下载'],
      // 资料列表
      dataList: [],

      // 工具列表
      toolList: [],

      // 其他列表
      elseList: [],
      searchtitle: null,
      pagedata: {
        page: 1,
        size: 10,
        total: 0
      }
    };
  },
  computed: {
    ...mapState(["baseURL"])
  },
  filters: {
    filterTime(val) {
      return moment(val).format("YYYY-MM-DD");
    }
  },
  methods: {
    getActiveList (index) {
      this.pagedata = {
        page: 1,
        size: 10,
        total: 0
      } 
      this.tabActive = index
      switch(index) {
        case 0:
          this.downloadFile()
          break
        case 1: 
          this.downloadgj()
          break
        case 2:
          this.downloadother()
          break
      }
    },
    sizeChange (val) {
      console.log(val)
      this.$set(this.pagedata, 'page', val)
      let tabActive = this.tabActive
      switch(tabActive) {
        case 0:
          this.downloadFile()
          break
        case 1: 
          this.downloadgj()
          break
        case 2: 
          this.downloadother()
          break
      }
    },

    // 获取资料列表
    downloadFile() {
      downloadSectionApi
      .getDataList({
        page: this.pagedata.page,
        size: this.pagedata.size,
        sort: "desc",
        sortFiled: "modify_time",
        title: this.searchtitle,
      })
      .then(res => {
        this.dataList = res.data.records;
        this.$set(this.pagedata, 'total', res.data.total)
      });
    },

    // 获取工具列表
    downloadgj () {
      downloadSectionApi
      .getToolList({
        page: this.pagedata.page,
        size: this.pagedata.size,
        sort: "desc",
        sortFiled: "modify_time",
        title: this.searchtitle,
      })
      .then(res => {
        this.dataList = res.data.records;
        this.$set(this.pagedata, 'total', res.data.total)
      });
    },

    // 获取其他列表
    downloadother () {
      downloadSectionApi
      .getElseList({
        page: this.pagedata.page,
        size: this.pagedata.size,
        sort: "desc",
        sortFiled: "modify_time",
        title: this.searchtitle,
      })
      .then(res => {
        this.dataList = res.data.records;
        this.$set(this.pagedata, 'total', res.data.total)
      });
    },

    // 下载相关函数
    handleDownload(v) {
      let path = v.attachFilePath
      try {
        path = JSON.parse(path)[0]
      } catch (error) {}
      window.open(this.baseURL + path);
    }
  }
};
</script>

<style lang="less" scoped>
.download-section {
  display: flex;
  .listpage-left-title {
    .line1 {
      background-image: url(~@/assets/images/download/titel_bj_xzzq@2x.png);
    }
  }
  // 主体
  .main {
    padding-top: 20px;
    flex: 1;
    ul {
      margin-bottom: 30px;
      // 标题
      .title {
        display: flex;
        justify-content: space-between;
        text-align: center;
        line-height: 30px;
        border-bottom: 1px solid #dcdcdc;
        margin-bottom: 20px;
        .title-left {
          width: 120px;
          background: #3660d9;
          color: white;
        }
        .title-right {
          font-size: 14px;
          width: 70px;
          color: #ababab;
          cursor: pointer;
        }
      }

      // item
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        border-bottom: 1px dashed rgba(236, 236, 241, 1);
        font-size: 18px;
        color: rgba(32, 32, 30, 1);
        &::before {
          content: '·';
          color: rgba(243, 110, 49, 1);
          margin-right: 4px;
          font-size: 24px;
        }
        .item-title {
          flex: 1;
        }
        .downloadbtn {
          cursor: pointer;
          img {
            width: 24px;
            margin-right: 2px;
          }
        }
        .item-date {
          color: #979797;
          font-size: 14px;
          border-right: 1px solid rgba(216, 216, 216, 1);
          padding-right: 8px;
          margin-right: 8px;
          height: 20px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>